import React, { useState } from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { withLocalizeStrings } from "../../../languages/Localize";
import Checkbox from "../../../components/inputs/Checkbox";
import BasicButton from "../../../components/buttons/basic-button/Button";
import PaymentLogos from "../../../components/payment-logos/PaymentLogos";
import { Modal } from "antd";
import StyledButton from "../../../components/buttons/basic-button/Button";
import { useRegisterStateValue } from "../../RegisterContext";
import parse from "html-react-parser";
import axios from "axios";

const ConfirmTerms = ({ strings }) => {
    const [isChecked, setChecked] = useState(false);
    const [isInfoModalVisible, setInfoModalVisible] = useState(false);
    const [modalHeaderTitle, setModalHeaderTitle] = useState("");
    const { nextScreen, purchaserForm } = useRegisterStateValue();
    const [html, setHtml] = useState("");

    const handleInfoModalOk = () => {
        setInfoModalVisible(false);
    };

    return (
        <div>
            <StyledHeader>
                <StyledHeaderLabel sx={{ fontWeight: "light", fontSize: [5, 6], mt: [3, 4], p: [1, 2] }}>
                    {strings.register.common.CONFIRM_TERMS_HEADER}
                </StyledHeaderLabel>
                <div className="divider" />
            </StyledHeader>
            <AccreditationBox>
                <AccreditationLabel>{strings.register.confirmTerms.chosenAccreditationLabel}</AccreditationLabel>
                <AccreditationNamePriceBox>
                    <AccreditationNameBox>
                        {purchaserForm.conferenceAttendType === "LIVE"
                            ? strings.register.confirmTerms.accreditationNameLive
                            : strings.register.confirmTerms.accreditationNameOnline}
                    </AccreditationNameBox>
                    <AccreditationPriceBox>
                        {" "}
                        {purchaserForm.conferenceAttendType === "LIVE"
                            ? strings.register.confirmTerms.priceLive
                            : strings.register.confirmTerms.priceOnline}
                    </AccreditationPriceBox>
                </AccreditationNamePriceBox>
            </AccreditationBox>
            <Divider />
            <SectionBox>
                <SectionLabel>{strings.register.confirmTerms.basisLabel}</SectionLabel>
                <SectionValue>
                    {purchaserForm.conferenceAttendType === "LIVE"
                        ? strings.register.confirmTerms.basisValueLive
                        : strings.register.confirmTerms.basisValueOnline}
                </SectionValue>
            </SectionBox>
            <Divider />
            <SectionBox>
                <SectionLabel>{strings.register.confirmTerms.vatLabel}</SectionLabel>
                {purchaserForm.conferenceAttendType === "LIVE"
                    ? strings.register.confirmTerms.vatValueLive
                    : strings.register.confirmTerms.vatValueOnline}
            </SectionBox>
            <Divider />
            <SectionBox isbold={1}>
                <SectionLabel>{strings.register.confirmTerms.amountToPayLabel}</SectionLabel>
                {purchaserForm.conferenceAttendType === "LIVE"
                    ? strings.register.confirmTerms.amountToPayValueLive
                    : strings.register.confirmTerms.amountToPayValueOnline}
            </SectionBox>
            <Divider />
            <ConfirmTermsBox>
                <Checkbox
                    onChange={e => {
                        setChecked(e.target.checked);
                    }}
                    checked={isChecked}></Checkbox>
                <ConfirmTermsLabel>
                    {strings.register.confirmTerms.agree}
                    <StyledLink
                        onClick={async () => {
                            try {
                                const response = await axios.get("/static-texts/uslovi_koriscenja_prodaje.html");
                                setHtml(response.data);
                                setModalHeaderTitle(strings.register.confirmTerms.termsOfUseHeader);
                                setInfoModalVisible(true);
                            } catch (e) {
                                console.error(e);
                            }
                        }}>
                        {strings.register.confirmTerms.termsOfUseLabel}
                    </StyledLink>
                </ConfirmTermsLabel>
            </ConfirmTermsBox>
            <PayBox>
                <BasicButton
                    disabled={!isChecked}
                    onClick={() => {
                        nextScreen();
                    }}>
                    {strings.register.confirmTerms.actionButton}
                </BasicButton>
            </PayBox>
            <PaymentLogosBox>
                <PaymentLogosInner>
                    <PaymentLogos></PaymentLogos>
                </PaymentLogosInner>
            </PaymentLogosBox>
            <StatementsBox>
                <SafetyBox>
                    <StyledLink
                        smallfont={1}
                        onClick={async () => {
                            try {
                                const response = await axios.get("/static-texts/sigurnost_placanja.html");
                                setHtml(response.data);
                                setModalHeaderTitle(strings.register.confirmTerms.safePayment);
                                setInfoModalVisible(true);
                            } catch (e) {
                                console.error(e);
                            }
                        }}>
                        {strings.register.confirmTerms.safePayment}
                    </StyledLink>
                </SafetyBox>
                <PrivacyAndConversionBox>
                    <StyledLink
                        onClick={async () => {
                            try {
                                const response = await axios.get("/static-texts/izjava_o_privatnosti.html");
                                setHtml(response.data);
                                setModalHeaderTitle(strings.register.confirmTerms.privacyStatement);
                                setInfoModalVisible(true);
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        smallfont={1}>
                        {strings.register.confirmTerms.privacyStatement}
                    </StyledLink>
                    <StyledLink
                        onClick={async () => {
                            try {
                                const response = await axios.get("/static-texts/izjava_o_konverziji.html");
                                setHtml(response.data);
                                setModalHeaderTitle(strings.register.confirmTerms.conversionStatement);
                                setInfoModalVisible(true);
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        smallfont={1}>
                        {strings.register.confirmTerms.conversionStatement}
                    </StyledLink>
                </PrivacyAndConversionBox>
            </StatementsBox>
            <StyledModal
                visible={isInfoModalVisible}
                onOk={handleInfoModalOk}
                onCancel={handleInfoModalOk}
                title={modalHeaderTitle}
                footer={
                    <InfoModalOkBox>
                        <StyledButton onClick={handleInfoModalOk}>OK</StyledButton>
                    </InfoModalOkBox>
                }>
                <InfoModalTextBox>{parse(html)}</InfoModalTextBox>
            </StyledModal>
        </div>
    );
};

const StyledHeader = styled(Flex)`
    flex-direction: column;
    align-items: flex-start;
    .divider {
        background: ${({ theme }) => theme.colors.white};
        height: 2px;
        width: 100%;
    }
`;

const Divider = styled(Box)`
    background: ${({ theme }) => theme.colors.white};
    height: 2px;
    width: 100%;
`;

const StyledHeaderLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    font-size: 16px;
    && {
        margin-left: 10px;
        padding-left: 6px;
        margin-top: 2px;
    }
`;

const SectionBox = styled(Flex)`
    flex-display: row;
    justify-content: space-between;
    height: 32px;
    align-items: center;
    font-weight: ${({ isbold }) => isbold && 600};
    color: #fff;
    div {
        opacity: ${({ isbold }) => (isbold ? 1 : 0.85)};
    }
    && {
        margin: auto 16px;
    }
`;

const SectionLabel = styled(Flex)`
    flex: 2;
`;

const SectionValue = styled(Flex)`
    flex: 1;
    text-align: right;
    justify-content: flex-end;
`;

const AccreditationBox = styled(Flex)`
    flex-direction: column;
    color: #fff;
    && {
        margin: 18px;
    }
`;

const AccreditationLabel = styled(Flex)`
    opacity: 0.85;
`;

const AccreditationNamePriceBox = styled(Flex)`
    flex-direction: row;
    font-size: 14px;
    && {
        margin: 10px 0px 10px 0px;
    }
`;

const AccreditationNameBox = styled(Flex)`
    font-weight: 600;
    flex: 2;
`;

const AccreditationPriceBox = styled(Flex)`
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    && {
        margin-left: 20px;
    }
`;

const ConfirmTermsBox = styled(Flex)`
    align-items: center;
    justify-content: center;
    margin: 8px 16px;
`;

const ConfirmTermsLabel = styled(Flex)`
    color: #fff;
    height: 32px;
    font-size: 13px;
    align-items: flex-end;
    padding-bottom: 6px;
    font-weight: 600;
    && {
        padding-left: 8px;
    }
`;

const StyledLink = styled.a`
    color: #fff;
    text-decoration: underline;
    && {
        margin-left: 4px;
    }
    font-size: ${({ smallfont }) => smallfont && "12px"};
`;

const PayBox = styled(Flex)`
    justify-content: center;
    align-items: center;
    flex: 1;
`;

const PaymentLogosBox = styled(Flex)`
    flex-wrap: wrap;
    justify-content: center;
    flex: 1;
    && {
        margin: 26px auto 22px auto;
    }
`;

const PaymentLogosInner = styled(Flex)`
    width: 226px;
    gap: 12px;
    flex-wrap: wrap;
`;

const StatementsBox = styled(Flex)`
    flex: 1;
    flex-direction: column;
    gap: 6px;
    opacity: 0.85;
    padding-bottom: 8px;
`;

const SafetyBox = styled(Flex)`
    justify-content: center;
    && {
        margin: auto 16px;
    }
`;

const PrivacyAndConversionBox = styled(Flex)`
    flex: 1;
    justify-content: space-between;
    && {
        margin: auto 16px;
    }
`;

const InfoModalTextBox = styled.div`
    padding-top: 8px;
`;

const InfoModalOkBox = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
`;

const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 14px;
    }

    .ant-modal-header {
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
    }

    .ant-modal-title {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export default withLocalizeStrings(ConfirmTerms);
